import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import GenericFormContainer from '../../../helpers/GenericFormContainer';
import {UserService} from '../../../services/UserService';

import styles from './EmailVerification.module.scss';
import AuthGeneric from '../../../components/Auth/layouts/AuthGeneric'
import RoundedButton from '../../../components/Auth/atoms/buttons/RoundedButton'
import ModalButton from '../../../components/Auth/atoms/modals/ModalButton'

import Logo from '../../../components/Auth/atoms/images/Logo'
import i18n from 'i18n';

export class EmailVerificationView extends GenericFormContainer {
    constructor(props) {
        super(props);
        this.state = {
            email: null,
            type: 'register', // register, forgot

            sent: false,
        }
       
    }

    componentDidMount(){
        if(!this.props.location.state || !this.props.location.state.email){
            this.props.history.push('/');
        }

        this.setState({
            email: this.props.location.state.email,
            type: this.props.location.state.type
        })
    }

    resetSent = () => {
        this.setState({
            sent: false
        })
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.beforeSubmit();
        const data = {
            email: this.state.email,
        }
        if (this.state.type === 'register') {
            UserService.resendMail(data
            ).then(data => {
                this.afterSubmit();
                this.setState({
                    sent: true
                })
                this.timeoutSent = setTimeout(() => {
                    this.resetSent()
                }, 4000);
            }).catch((error) => {
                this.afterSubmit();
                this.dealWithError(error, i18n.t("there.was.error"));
            });
        } else {
            UserService.resetPassword(data
            ).then(data => {
                this.afterSubmit();
                this.setState({
                    sent: true
                })
                this.timeoutSent = setTimeout(() => {
                    this.resetSent()
                }, 4000);
            }).catch((error) => {
                this.afterSubmit();
                this.dealWithError(error, i18n.t("there.was.error"));
            });
        }
    };

    render() {
        const title = this.state.type === 'register' ? i18n.t("confirm.account") : i18n.t("forgot.password");

        const content = <div className={styles['email-verification']}>
            <Logo></Logo>
            <i className='icon icon-reenviar-email'></i>
            <p className={styles['title']}>{i18n.t("check.your.email")}</p>
            <p className={styles['subtitle']}>
                {i18n.t("we.have.sent.email")}<br></br>
                <span className={styles['bold']}>{this.props.location.state.email}</span>
                {this.state.type === 'forgot' ? i18n.t("you.can.reset.password") : ''}
            </p>
            
            <div className={styles['question-wrapper']}>
                <p className={styles["question"]}>{i18n.t("received.email.question")}</p>
                <p className={styles["answer"]}>{i18n.t("received.email.question.sub")}</p>
            </div>
            <div className={styles["rounded-button-wrapper"]}>
                <RoundedButton legend={this.state.sent ? i18n.t("sent-m") : i18n.t("forward-email")} handleSubmit={this.handleSubmit} state={this.state.submitted ? 'waiting' : (this.state.sent ? 'temporary' : 'enabled')} handleClick={this.handleSubmit} ></RoundedButton>
            </div>
            <div className={styles["modal-button-wrapper"]}>
                <Link to="/create" className={styles["link"]}><ModalButton label={i18n.t("change.email")}></ModalButton></Link>
            </div>
        </div>

        return (
            <div className={styles['email-verification-container']}>
                <AuthGeneric title={title} version={'header'} content={content} ></AuthGeneric>
            </div>
        )
    }

}


EmailVerificationView.propTypes = {
    handleChange: PropTypes.func,
    label: PropTypes.string
};

export default EmailVerificationView;